import { Button, Modal } from 'flowbite-react'
import { HiOutlineExclamationCircle } from 'react-icons/hi'
interface DeleteModalProps {
  isOpen: boolean | false
  onClose: any
  onDelete: () => void
  content?: string
}
export default function DeleteModal({
  isOpen,
  onClose,
  onDelete,
  content = 'excluir'
}: DeleteModalProps) {
  const handleDelete = () => {
    onDelete()
    onClose()
  }

  return isOpen ? (
    <>
      <Modal show={isOpen} size='md' onClose={onClose} popup>
        <Modal.Header />
        <Modal.Body>
          <div className='text-center'>
            <HiOutlineExclamationCircle className='mx-auto mb-4 h-14 w-14 text-red-700' />
            <h3 className='mb-0 text-lg font-normal text-gray-500'>
              Deseja {content} este item?
            </h3>
            <p className='text-sm text-gray-400 mb-5'>
              essa operação não poderá ser desfeita.
            </p>
            <div className='flex justify-center gap-4'>
              <Button color='failure' onClick={handleDelete}>
                Sim
              </Button>
              <Button color='gray' onClick={onClose}>
                Cancelar
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  ) : (
    <></>
  )
}
